var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoArrowDownBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52301 5.61885C2.25593 5.3574 2.25593 4.9275 2.52301 4.66605L2.72073 4.4725C2.97988 4.2188 3.39429 4.21881 3.65344 4.4725L8.03635 8.76301L12.4193 4.47249C12.6784 4.2188 13.0928 4.2188 13.352 4.47249L13.5497 4.66605C13.8168 4.9275 13.8168 5.3574 13.5497 5.61885L8.50271 10.5594C8.24355 10.8131 7.82914 10.8131 7.56999 10.5594L2.52301 5.61885Z",
    fill: "#0C002C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3748 5.4402C13.5417 5.27679 13.5417 5.00811 13.3748 4.8447L13.1771 4.65114C13.0151 4.49259 12.7561 4.49259 12.5941 4.65114L8.03635 9.11286L3.47856 4.65114C3.31659 4.49259 3.05758 4.49259 2.89561 4.65114L2.69789 4.8447C2.53097 5.00811 2.53097 5.27679 2.69789 5.4402L7.74488 10.3808C7.90685 10.5393 8.16585 10.5393 8.32782 10.3808L13.3748 5.4402ZM13.7246 4.4874C14.0918 4.84689 14.0918 5.438 13.7246 5.7975L8.67759 10.7381C8.32125 11.0869 7.75144 11.0869 7.39511 10.7381L2.34812 5.7975C1.98089 5.438 1.98089 4.8469 2.34812 4.4874L2.54585 4.29385C2.90218 3.94502 3.47199 3.94502 3.82833 4.29385L8.03635 8.41316L12.2444 4.29384C12.6007 3.94502 13.1705 3.94502 13.5269 4.29384L13.7246 4.4874Z",
    fill: "#0C002C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowDownBold);
export default __webpack_public_path__ + "static/media/ico_arrow_down_bold.e92943c0b9c02143809bb70f47885eb5.svg";
export { ForwardRef as ReactComponent };